<template>
    <div class="feedback-explain">
        <body-feedback 
            :index="index"
            :beforeBold='$t("views.feedback.Explain.body[0]")'
            actionName="sendExplain">
            <text-area-default
                :placeholder='$t("views.feedback.Explain.body[1]")'>
            </text-area-default>
        </body-feedback>
        <span class="problem-desc"
        :style="{ 
            color: colors.theme == 'dark' ? '#fff' : '#000',
        }">{{$t("views.feedback.Explain.body[2]")}}</span>
        <div class="button button-feedback" @click="mailto()">
            <button
            :style="{ 
                color: colors.theme == 'dark' ? '#fff' : '#000',
                'background' : 'none',
                'border': colors.theme == 'dark' ? '1px solid #fff' : '1px solid #000',
                'border-bottom' : colors.theme == 'dark' ? '1px solid #fff' : '1px solid #000'
            }">{{$t("views.feedback.Explain.buttonText")}}</button>    
        </div>          
    </div>
</template>
<script>
import BodyFeedback from '../../components/feedback/BodyFeedback.vue'
import TextAreaDefault from '../../components/Shared/TextAreaDefault'
import Bus from '../../main.js'
export default {
    components:{
        BodyFeedback,
        TextAreaDefault
    },
    data: function(){
        return{colors:{}}
    },    
    props:["index"],
    created(){
        Bus.$on('sendExplain', this.sendExplain)
        this.colors = JSON.parse(localStorage.getItem("colors"));
    },
    mounted(){
        Bus.$emit('ableButton')
    },
    destroyed(){
        Bus.$off('sendExplain')
    },
    methods : {
        mailto(){
            window.location.href='mailto:support@huddlebrasil.zendesk.com'
        },        
        sendExplain(){
            this.$store.dispatch('callSetFeedback', {
                itemName : 'problem',
                itemData : textArea.value
            })
            Bus.$emit('nextStep')
            this.$router.push('/feedback-gift')
        }
    }
}
</script>
<style lang="scss" scoped>
.feedback-explain .body-feedback{
        height: 66vh;
        /*overflow: hidden;*/
    }
    .problem-desc{
        margin: 0 auto;
        padding: 0 32px 32px;
        display: flex;
        font-size: 15px;
        text-align: center;
        justify-content: center;

    }
    .body-feedback .content-feedback .text-area-default .text-area{
        overflow-y: auto;
        height: 150px;
    }    
    .feedback-explain{
        width: 100%;


        .title{
            font-weight: 600;
        }
        .button-feedback{
            height: 40px;
            border: none;
            font-weight: bold;
            font-size: 30px;
            outline: none;
            letter-spacing: 2px;
            cursor: pointer;
            text-transform: uppercase;
            border-radius: 15px;
            display: flex;
            flex-direction: column;
            justify-content: center;
            align-items: center;    
            margin-bottom: 32px;
            
            button{
                max-width: 270px;
                border-radius: 300px;            
                width: 100%;
                font-weight: 900;
                text-transform: uppercase;
                font-size: 12px;
                padding: 15px;
            }
        }        
    }
    @media only screen and (min-width : 750px) {
        .feedback-explain .body-feedback{
            height: 45vh;
        }
    }    
</style>
